<div class="border border-gray-200 rounded-lg shadow-md bg-white">
  <button
    type="button"
    (click)="toggleExpanded()"
    class="w-full bg-white px-4 py-3 flex items-center justify-between hover:bg-gray-100 transition-colors rounded-t-lg">
    <span class="text-sm font-medium text-gray-700">{{ 'reportsFormat.title' | translate }}</span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="2"
      stroke="currentColor"
      class="w-5 h-5 text-gray-600 transform transition-transform duration-200"
      [class.rotate-180]="isExpanded()">
      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
    </svg>
  </button>
  @if (isExpanded()) {
    <div class="border-t border-gray-200 p-4 space-y-3">
      <div class="flex flex-col gap-1">
        <label
          for="reports-format-title"
          class="text-xs font-medium text-gray-500 uppercase tracking-wide">
          {{ 'reportsFormat.controlTitle' | translate }}
        </label>
        <div
          class="flex items-center rounded-md bg-gray-50 pl-3 outline-1 -outline-offset-1 outline-gray-200">
          <span class="block min-w-0 grow py-1.5 pr-3 pl-1 text-sm text-gray-500">{{
            title()
          }}</span>
        </div>
      </div>
      <div class="flex flex-col gap-1">
        <label
          for="reports-format-tag"
          class="text-xs font-medium text-gray-500 uppercase tracking-wide">
          {{ 'reportsFormat.controlTag' | translate }}
        </label>
        <div
          class="flex items-center rounded-md bg-white pl-3 outline-1 -outline-offset-1 outline-gray-300 focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-main">
          <input
            type="text"
            id="reports-format-tag"
            [value]="tag()"
            (input)="onTagInput($event)"
            class="block min-w-0 grow bg-transparent py-1.5 pr-3 pl-1 text-sm text-gray-900 placeholder:text-gray-500 focus:outline-none" />
        </div>
      </div>
      @if (selectorProvidersSupported()) {
        <div class="flex flex-col gap-1">
          <label
            for="reports-format-selector-provider"
            class="text-xs font-medium text-gray-500 uppercase tracking-wide">
            {{ 'reports.selectorProvider' | translate }}
          </label>

          @if (selectorProvidersLoading()) {
            <div class="flex items-center justify-center py-2">
              <cmi-loading-spinner />
            </div>
          } @else if (selectorProvidersError()) {
            <cmi-notification
              mode="error"
              [message]="'common.notifications.errorTitle' | translate"
              [description]="'common.notifications.loadingFailed' | translate"
              [actionLabel]="'common.notifications.retry' | translate"
              (action)="reloadSelectorProviders()" />
          } @else {
            <div
              class="relative flex items-center rounded-md bg-white outline-1 -outline-offset-1 outline-gray-300 focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-main">
              <select
                id="reports-format-selector-provider"
                (change)="onProviderChange($event)"
                class="w-full appearance-none bg-transparent py-1.5 pl-3 pr-8 text-sm text-gray-900 focus:outline-none">
                <option value="" [selected]="selectedProvider() === ''">
                  {{ 'reports.selectorProviderPlaceholder' | translate }}
                </option>
                @for (provider of selectorProviders(); track provider.key) {
                  <option [value]="provider.key" [selected]="provider.key === selectedProvider()">
                    {{ provider.displayName }}
                  </option>
                }
              </select>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="pointer-events-none absolute right-2 size-4 text-gray-500">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m19.5 8.25-7.5 7.5-7.5-7.5" />
              </svg>
            </div>
          }
        </div>
      }
      <div class="flex justify-start">
        <cmi-button
          [label]="'reportsFormat.save' | translate"
          [loading]="isSaving()"
          [disabled]="isSaving()"
          (clicked)="onSave()" />
      </div>
      @if (duplicateError()) {
        <cmi-notification mode="error" [message]="'reportsFormat.duplicateError' | translate" />
      }
      @if (saveError()) {
        <cmi-notification mode="error" [message]="'reportsFormat.saveError' | translate" />
      }
    </div>
  }
</div>
